import * as React from "react";
import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react";
import JobOfferRequestEdit from "./JobOfferRequestEdit";
import JobOfferRequestList from "./JobOfferRequestList";

type Props = RouteComponentProps<{ entityId?: string }>;

@observer
export class JobOfferRequestManagement extends React.Component<Props> {
  static PATH = "/jobOfferRequest";
  static NEW_SUBPATH = "new";

  render() {
    const { entityId } = this.props.match.params;
    return (
      <>
        {entityId ? (
          <JobOfferRequestEdit entityId={entityId} />
        ) : (
          <JobOfferRequestList />
        )}
      </>
    );
  }
}
